import { render, staticRenderFns } from "./FactoryWaterQualityMonitoring.vue?vue&type=template&id=0d5f61fb&scoped=true"
import script from "./FactoryWaterQualityMonitoring.vue?vue&type=script&lang=js"
export * from "./FactoryWaterQualityMonitoring.vue?vue&type=script&lang=js"
import style0 from "./FactoryWaterQualityMonitoring.vue?vue&type=style&index=0&id=0d5f61fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f61fb",
  null
  
)

export default component.exports